export default class J2HProtocol {
  static READY_ROUND = "READY_ROUND";
  static START_ROUND = "START_ROUND";
  static ROUND_LEFT_TIME = "ROUND_LEFT_TIME";
  static DISABLED_DESTINATIONS = "DISABLED_DESTINATIONS";
  static GAME_OVER = "GAME_OVER";
}
